import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Home: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      navigate('/tools');
    } else {
      // Redirect to www.soundlegal.ai
      window.location.replace('https://www.soundlegal.ai');
    }
  }, [navigate]);

  // Return null since we're redirecting immediately
  return null;
};

export default Home;
